var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showCookieBanner
        ? _c("ui-alert", {
            attrs: { position: "bottom", "no-icon": "", "full-width": "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "description",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: { click: _vm.handleClose },
                        },
                        [_c("svg-alert-close")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("small", {
                            domProps: { innerHTML: _vm._s(_vm.i18n.alertText) },
                          }),
                          _vm._v(" "),
                          _c("ui-button", {
                            staticClass: "mx-2",
                            attrs: { label: _vm.i18n.iAccept },
                            on: { click: _vm.handleConfirm },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2326010444
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }